import { useEffect, useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import api from "../lib/apiClient";
import { toast } from "sonner";

function AdminImg({ path }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let off = false; let obj;
    api.get(`/media/${path}`, { responseType: "blob" }).then((r) => { if (!off) { obj = URL.createObjectURL(r.data); setSrc(obj); } }).catch(() => {});
    return () => { off = true; if (obj) URL.revokeObjectURL(obj); };
  }, [path]);
  if (!src) return <div className="aspect-square bg-zinc-900 flex items-center justify-center"><Loader2 className="w-5 h-5 text-amber-500 animate-spin" /></div>;
  return <img src={src} alt="visuel" className="w-full aspect-square object-cover" />;
}

export default function AdminContent() {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(0);
  const load = () => api.get(`/admin/content/images?page=${page}`).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, [page]);

  const del = async (id) => {
    if (!window.confirm("Supprimer ce visuel ?")) return;
    try { await api.delete(`/admin/content/images/${id}`); toast.success("Visuel supprimé"); load(); }
    catch { toast.error("Échec"); }
  };

  if (!data) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-amber-500 animate-spin" /></div>;
  return (
    <div className="space-y-5" data-testid="admin-content">
      <h1 className="font-display text-3xl font-extrabold">Modération — visuels</h1>
      {data.images.length === 0 ? <p className="text-zinc-500 text-sm">Aucun visuel généré.</p> : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="admin-images-grid">
          {data.images.map((img) => (
            <div key={img.id} className="group relative bg-[#18181E] border border-zinc-800 rounded-2xl overflow-hidden" data-testid={`admin-image-${img.id}`}>
              <AdminImg path={img.media_path} />
              <div className="p-2">
                <p className="text-[11px] text-zinc-400 line-clamp-1">{img.prompt}</p>
                <p className="text-[10px] text-zinc-600 truncate">{img.owner_email}</p>
              </div>
              <button onClick={() => del(img.id)} data-testid={`admin-image-del-${img.id}`}
                className="absolute top-2 right-2 w-8 h-8 rounded-lg bg-black/60 backdrop-blur flex items-center justify-center text-zinc-300 hover:text-red-400">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
      <div className="flex justify-between pt-2">
        <button disabled={page === 0} onClick={() => setPage((p) => p - 1)} className="h-9 px-4 rounded-lg text-sm bg-zinc-900 border border-zinc-800 disabled:opacity-40">Précédent</button>
        <button disabled={!data.has_more} onClick={() => setPage((p) => p + 1)} className="h-9 px-4 rounded-lg text-sm bg-zinc-900 border border-zinc-800 disabled:opacity-40">Suivant</button>
      </div>
    </div>
  );
}
